var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "logout",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u0412\u044B\u0439\u0442\u0438") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16a1.5 1.5 0 0 0-1.5 1.5v.8A2.7 2.7 0 0 1 7.3 21H5.7A2.7 2.7 0 0 1 3 18.3V5.7A2.7 2.7 0 0 1 5.7 3h1.6A2.7 2.7 0 0 1 10 5.7v.8a1.5 1.5 0 0 0 3 0v-.8A5.706 5.706 0 0 0 7.3 0H5.7A5.706 5.706 0 0 0 0 5.7v12.6A5.706 5.706 0 0 0 5.7 24h1.6a5.706 5.706 0 0 0 5.7-5.7v-.8a1.5 1.5 0 0 0-1.5-1.5Z",
    fill: "#000000",
    "data-original": "#000000",
    className: "logout"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.561 9.525-4.586-4.586a1.5 1.5 0 0 0-2.121 2.122l3.411 3.411L7 10.5a1.5 1.5 0 0 0 0 3l12.318-.028-3.467 3.467a1.5 1.5 0 0 0 2.121 2.122l4.586-4.586a3.505 3.505 0 0 0 .003-4.95Z",
    fill: "#000000",
    "data-original": "#000000",
    className: "logout"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8b146ff9d6245bf982a977331643c1d2.svg";
export { ForwardRef as ReactComponent };